import shaka from 'shaka-player';
import defaults from 'lodash/defaults';
import mapValues from 'lodash/mapValues';

const { Player: { version }, util: { Error } } = shaka;
const ERROR_NAMES_BY_CODE = Object.fromEntries(Object.entries(Error.Code).map(([name, code]) => [code, name]));
const DEFAULT_OPTIONS = {
  disableInitOnLoading: false,
  reportLoadInterruptedError: false,
  errorCodesToAvoid: [],
  fatalErrorCodes: [],
  nonFatalErrorCodes: [],
  errorParser: defaultErrorParser,
  getErrorDetails: defaultGetErrorDetails
};
const DEFAULT_AD_OPTIONS = {
  errorParser: defaultErrorParser,
  getErrorDetails: defaultGetErrorDetails
};
function getPlayerVersion() {
  return version.replace(/v/i, "");
}
function defaultGetErrorDetails(error) {
  return error;
}
function defaultErrorParser(error) {
  return {
    name: "Shaka Error",
    description: `${error.code} - ${ERROR_NAMES_BY_CODE[error.code]}`
  };
}
function completeWithDefaults(options = {}, defaultOptions = DEFAULT_OPTIONS) {
  return defaults(mapNullToUndefined(options), defaultOptions);
}
function nullToUndefined(value) {
  return value === null ? void 0 : value;
}
function mapNullToUndefined(iterable) {
  return mapValues(iterable, nullToUndefined);
}

export { DEFAULT_AD_OPTIONS, DEFAULT_OPTIONS, completeWithDefaults, defaultErrorParser, defaultGetErrorDetails, getPlayerVersion, mapNullToUndefined, nullToUndefined };
//# sourceMappingURL=utils.js.map
